import React from 'react';
import { END_LINK_ROWS, endLinkBase, endLinkUrl, singleEndLink, tokenOrDefault } from '../../Utils/endLinks';

// Universal returns B1 — the client's ready-to-paste end links: our four
// static /r links with the client's respondent-id token, and the single-URL
// form. Set once at the account / supplier level of the client's platform,
// they work for every project (static links carry no survey id).
export const EndLinkKit: React.FC<{ idToken?: string | null }> = ({ idToken }) => {
    const base = endLinkBase();
    const token = tokenOrDefault(idToken);
    const copy = (text: string) => {
        try { navigator.clipboard.writeText(text); } catch (e) { /* clipboard unavailable */ }
    };
    const line = (label: string, url: string) => (
        <div className="row mt-1" key={label}>
            <div className="col" style={{ wordBreak: 'break-all' }}>
                <strong>{label}: </strong>
                <code>{url}</code>
                <button type="button" className="btn btn-link btn-sm py-0" onClick={() => copy(url)}>Copy</button>
            </div>
        </div>
    );
    return (
        <div className="mt-3">
            <h6 className="mb-1">End links — set at account / supplier level</h6>
            <div className="text-muted mb-2" style={{ fontSize: '0.9em' }}>
                Respondent ID token: <code>{token}</code>
                {!idToken ? ' (default; set the client\'s token with Update)' : ''}.
                The same links work for every project of this client.
            </div>
            {END_LINK_ROWS.map(([label, slug]) => line(label, endLinkUrl(base, slug, idToken)))}
            <div className="mt-2" style={{ fontSize: '0.9em' }}>
                <strong>Or one URL for every outcome</strong> (status 1 complete, 2 terminate, 3 over quota, 4 quality):
            </div>
            {line('Single URL', singleEndLink(base, idToken))}
        </div>
    );
};
